var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "contenteditableInput",
    staticClass: "input_outer",
    class: [_vm.gradient ? 'gradient' : '', _vm.elementStyle ? 'is-elem-input' : '']
  }, [_vm.sentiment ? _c('el-select', {
    staticClass: "yq-template-select",
    attrs: {
      "size": "mini",
      "placeholder": _vm.$t('common.Select-Template')
    },
    on: {
      "change": _vm.onSentimentTemplateChange
    },
    model: {
      value: _vm.selectedSentimentTemplate,
      callback: function ($$v) {
        _vm.selectedSentimentTemplate = $$v;
      },
      expression: "selectedSentimentTemplate"
    }
  }, _vm._l(_vm.sentimentTemplates, function (ite) {
    return _c('el-option', {
      key: ite.name,
      attrs: {
        "value": ite.content,
        "label": ite.name
      }
    });
  }), 1) : _vm._e(), _vm.replyMessage.length ? _c('div', {
    staticClass: "do_reply_message"
  }, [_c('p', {
    staticClass: "ellipsis-1-text"
  }, [_vm._v(_vm._s(_vm.replyMessage))]), _c('iconfont', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right.light.transition",
      value: _vm.$t('common.Cancel-Reply'),
      expression: "$t('common.Cancel-Reply')",
      modifiers: {
        "right": true,
        "light": true,
        "transition": true
      }
    }],
    staticClass: "pointer",
    attrs: {
      "icon": "mc-icon-guanbi",
      "size": 12
    },
    on: {
      "click": function ($event) {
        return _vm.cancelReplyItem();
      }
    }
  })], 1) : _vm._e(), _c('div', {
    ref: "inputDiv",
    staticClass: "input-div input-typing-comp-instance",
    style: {
      minHeight: `${_vm.height}px`
    },
    attrs: {
      "placeholder": _vm.placeholder,
      "contenteditable": _vm.contenteditable
    },
    on: {
      "keydown": function ($event) {
        return _vm.inputKeydown($event);
      },
      "input": function ($event) {
        return _vm.inputting($event);
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "paste": _vm.handlePaste
    }
  }), _vm.isTranslating ? _c('div', {
    staticClass: "input-trans-loading"
  }, [_vm._v(_vm._s(_vm.$t("common.Translating")))]) : _vm._e(), _vm.isUploading ? _c('div', {
    staticClass: "input-trans-loading"
  }, [_vm._v(_vm._s(_vm.$t("common.Uploading")))]) : _vm._e(), _vm.fileList.length ? _c('div', {
    staticClass: "fileList"
  }, _vm._l(_vm.fileList, function (item) {
    return _c('div', {
      key: item.pic_osskey,
      staticClass: "file-item"
    }, [_c('el-image', {
      attrs: {
        "src": item.pic_url,
        "fit": "cover",
        "preview-src-list": _vm.srcList
      },
      scopedSlots: _vm._u([{
        key: "error",
        fn: function () {
          return [_c('div', [_c('i', {
            staticClass: "el-icon-picture-outline"
          })])];
        },
        proxy: true
      }], null, true)
    }), _c('i', {
      staticClass: "el-icon-error",
      on: {
        "click": function ($event) {
          return _vm.delFile(item);
        }
      }
    })], 1);
  }), 0) : _vm._e(), _vm.inputText.length && _vm.inputTextTrans ? _c('el-divider', {
    staticClass: "trans-divider"
  }, [_vm._v(_vm._s(_vm.$t("common.Translate-Result")))]) : _vm._e(), _vm.inputText.length && _vm.inputTextTrans ? _c('div', {
    staticClass: "input-trans",
    domProps: {
      "innerHTML": _vm._s(_vm.inputTextTrans)
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.contenteditable,
      expression: "contenteditable"
    }],
    staticClass: "input-btn-group"
  }, [_c('div', {
    staticClass: "flex-box align-items-center"
  }, [_vm.emoji ? _c('emojiPopover', {
    ref: "emojiPopover",
    on: {
      "select": _vm.selectEmoji
    }
  }, [_c('icon-btn', {
    attrs: {
      "icon": "mc-icon-biaoqing"
    }
  })], 1) : _vm._e(), _vm.upload ? _c('el-upload', {
    attrs: {
      "accept": "image/*",
      "action": "#",
      "on-exceed": _vm.handleExceed,
      "http-request": _vm.handleUpload,
      "before-upload": _vm.beforeUpload,
      "show-file-list": false
    }
  }, [_vm.upload ? _c('icon-btn', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "icon": "mc-icon-tupian"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _c('div', {
    staticClass: "btns"
  }, [_vm.translate ? _c('el-popover', {
    ref: "translatePopper",
    attrs: {
      "placement": "top",
      "width": "200",
      "trigger": "click"
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function () {
        return [_c('el-button', {
          staticClass: "translate-btn",
          attrs: {
            "disabled": _vm.inputText.length === 0,
            "plain": "",
            "round": ""
          }
        }, [_vm._v(_vm._s(_vm.$t("common.Translate-Reply")))])];
      },
      proxy: true
    }], null, false, 3886044758)
  }, [_c('popoverLangsComp', {
    attrs: {
      "translatePopperVisible": _vm.translatePopperVisible
    },
    on: {
      "updatePop": _vm.updatePopper,
      "langClick": _vm.translateByLang
    }
  })], 1) : _vm._e(), _vm.inputTextTrans ? _c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "round": "",
      "plain": ""
    },
    on: {
      "click": _vm.transEnter
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Send-Translation")))]) : _vm._e(), _vm.sendable ? [_vm.gradient ? _c('icon-btn', {
    staticClass: "icon-send-btn",
    attrs: {
      "icon": "mc-icon-duihuafasong"
    },
    on: {
      "click": _vm.inputEnter
    }
  }) : _c('el-button', {
    staticClass: "send-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.inputEnter
    }
  }, [_c('iconfont', {
    staticStyle: {
      "color": "var(--mc-background-main-color)"
    },
    attrs: {
      "icon": "mc-icon-duihuafasong"
    }
  })], 1)] : _vm._e()], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };